function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var VDS = window.WinBoostAiDesignSystem_0f78b0;
var VAccordion = VDS.Accordion;
var VOICE_FAQ = [{
  q: 'Comment le WinBoost AI Phone comprend-il ce que disent les appelants?',
  a: 'Il \u00e9coute l\u2019appelant en temps r\u00e9el et transforme ses paroles en texte, puis d\u00e9termine ce dont il a besoin\u00a0: une r\u00e9servation, un prix, une r\u00e9ponse sur votre service. Ses r\u00e9ponses viennent des connaissances que vous lui donnez \u00e0 l\u2019int\u00e9gration, alors il parle de votre entreprise, pas en g\u00e9n\u00e9ralit\u00e9s.'
}, {
  q: 'Est-ce qu\u2019il parle comme un robot?',
  a: 'Non. Chaque r\u00e9ponse est prononc\u00e9e d\u2019une voix humaine naturelle, avec les pauses, le rythme et le ton d\u2019une vraie conversation. Il g\u00e8re les interruptions, comprend les accents et se souvient de ce qui a d\u00e9j\u00e0 \u00e9t\u00e9 dit, alors la plupart des appelants r\u00e9servent, posent leur question ou sont transf\u00e9r\u00e9s sans rien remarquer d\u2019inhabituel. Il peut m\u00eame parler avec la voix d\u2019un membre de votre \u00e9quipe.'
}, {
  q: "WinBoost AI peut-il cloner la voix d\u2019un membre de l\u2019\u00e9quipe?",
  a: "Oui, avec le consentement de cette personne. Elle enregistre un court \u00e9chantillon de voix, et votre AI Phone apprend son ton et sa chaleur. D\u00e8s lors, chaque appel qu\u2019il r\u00e9pond ou fait sonne comme quelqu\u2019un que vos clients connaissent d\u00e9j\u00e0."
}, {
  q: "La voix clon\u00e9e de mon membre d\u2019\u00e9quipe reste-t-elle priv\u00e9e?",
  a: "Oui. Une voix clon\u00e9e n\u2019est utilis\u00e9e que pour les appels de votre propre entreprise. Elle n\u2019est jamais partag\u00e9e ni utilis\u00e9e ailleurs, et elle peut \u00eatre supprim\u00e9e en tout temps sur demande."
}, {
  q: 'Peut-il g\u00e9rer les interruptions et les questions de suivi?',
  a: 'Oui. Il continue d\u2019\u00e9couter pendant qu\u2019il parle. Si un appelant l\u2019interrompt ou change d\u2019id\u00e9e, il s\u2019arr\u00eate, prend en compte ce qui a \u00e9t\u00e9 dit et poursuit \u00e0 partir de l\u00e0, comme le ferait une personne.'
}, {
  q: 'Comment r\u00e9serve-t-il des rendez-vous dans mon calendrier?',
  a: 'Il se connecte \u00e0 votre calendrier et v\u00e9rifie les plages libres en direct pendant que l\u2019appelant est en ligne. D\u00e8s que l\u2019appelant choisit une heure, il la r\u00e9serve, envoie tout de suite une confirmation par texto, puis le rappelle 24 h et 2 h avant le rendez-vous.'
},, {
  q: 'Quelle technologie WinBoost utilise-t-elle?',
  a: "Votre AI Phone fonctionne gr\u00e2ce \u00e0 la combinaison de technologies de parole, de langage et de voix propre \u00e0 WinBoost, r\u00e9gl\u00e9e sp\u00e9cialement pour les appels t\u00e9l\u00e9phoniques. Ce qui compte pour vous, c\u2019est le r\u00e9sultat\u00a0: il \u00e9coute, comprend et r\u00e9pond comme votre meilleure r\u00e9ceptionniste, \u00e0 chaque appel."
}];
function VBars(_ref) {
  var gold = _ref.gold,
    _ref$n = _ref.n,
    n = _ref$n === void 0 ? 22 : _ref$n;
  var H = [10, 18, 26, 14, 30, 20, 12, 24, 32, 16, 22, 28, 12, 20, 10, 18, 26, 12, 22, 16, 28, 14];
  return React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      height: 34
    }
  }, H.slice(0, n).map(function (h, i) {
    return React.createElement("span", {
      key: i,
      style: {
        width: 3,
        height: h,
        borderRadius: 2,
        background: gold ? 'linear-gradient(0deg,#FFAE06,#FC6306)' : 'var(--ink-300)'
      }
    });
  }));
}
function VoiceHow() {
  var stages = [{
    n: '01',
    t: 'L\u2019appelant parle',
    d: 'Un client appelle, \u00e0 n\u2019importe quelle heure du jour.',
    tag: 'Appel en direct',
    v: React.createElement(VBars, {
      n: 14
    })
  }, {
    n: '02',
    t: 'Il \u00e9coute',
    d: 'Leurs paroles deviennent du texte pendant qu\u2019ils parlent.',
    tag: 'Parole en texte',
    v: React.createElement("span", {
      style: {
        padding: '6px 10px',
        borderRadius: '12px 12px 12px 3px',
        background: 'var(--sand-100)',
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.3,
        color: 'var(--text-primary)'
      }
    }, "\u00ab\u00a0Puis-je r\u00e9server un nettoyage pour jeudi?\u00a0\u00bb")
  }, {
    n: '03',
    t: 'Il comprend',
    d: 'Il d\u00e9termine ce dont ils ont besoin et consulte votre calendrier.',
    tag: 'Compr\u00e9hension',
    v: React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement("img", {
      src: A + 'orbit.png',
      alt: "",
      style: {
        width: 30,
        height: 30,
        display: 'block'
      }
    }), React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4
      }
    }, React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '3px 8px',
        borderRadius: 999,
        background: 'var(--grad-brand-soft)',
        color: 'var(--text-primary)',
        whiteSpace: 'nowrap'
      }
    }, "Veut\u00a0: une r\u00e9servation"), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '3px 8px',
        borderRadius: 999,
        background: 'var(--grad-brand-soft)',
        color: 'var(--text-primary)',
        whiteSpace: 'nowrap'
      }
    }, "Jeu 10 h 30 libre")))
  }, {
    n: '04',
    t: "Il r\u00e9pond avec la voix de votre \u00e9quipe",
    d: 'Une r\u00e9ponse naturelle, dite comme parle votre \u00e9quipe.',
    tag: 'Texte en parole',
    v: React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement(VBars, {
      gold: true,
      n: 9
    }), React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 800,
        padding: '4px 9px',
        borderRadius: 999,
        background: 'var(--wb-orange)',
        color: 'var(--wb-white)',
        whiteSpace: 'nowrap'
      }
    }, "La voix de Sarah"))
  }];
  return React.createElement(Section, {
    id: "how-it-talks",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    label: "Comment il parle",
    title: "Comment votre AI Phone Lead Closer tient une vraie conversation.",
    lead: "Chaque appelant a un vrai \u00e9change, pas un menu. Voici ce qui se passe chaque fois qu\u2019il parle."
  }), React.createElement("div", {
    className: "vx-grid"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      minWidth: 0
    }
  }, React.createElement("div", {
    style: {
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)',
      overflow: 'hidden'
    }
  }, stages.map(function (s, i) {
    return React.createElement("div", {
      key: s.n,
      className: "vx-row",
      style: {
        borderTop: i ? '1px solid var(--border-hairline)' : 'none',
        background: i === 3 ? 'var(--grad-brand-soft)' : 'transparent'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '.1em',
        color: 'var(--wb-orange)'
      }
    }, s.n), React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        lineHeight: 1.25,
        color: 'var(--text-primary)'
      }
    }, s.t), React.createElement("span", {
      style: {
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: 'var(--ink-500)',
        padding: '2px 7px',
        border: '1px solid var(--border-hairline)',
        borderRadius: 999,
        background: 'var(--wb-white)'
      }
    }, s.tag)), React.createElement("span", {
      style: {
        fontSize: 13.5,
        lineHeight: 1.4,
        color: 'var(--text-secondary)'
      }
    }, s.d)), React.createElement("div", {
      className: "vx-vis"
    }, s.v));
  })), React.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      border: '1.5px solid var(--wb-orange)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)',
      padding: '18px 18px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      boxShadow: '0 12px 30px rgba(23,23,23,.07)'
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: '0 0 auto',
      height: 4,
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)'
    }
  }), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 5
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Clonage de voix \u00b7 avec consentement"), React.createElement("span", {
    style: {
      fontSize: 20,
      fontWeight: 800,
      letterSpacing: '-.02em',
      lineHeight: 1.2,
      color: 'var(--text-primary)'
    }
  }, "Les appelants entendent quelqu\u2019un qu\u2019ils connaissent d\u00e9j\u00e0."), React.createElement("span", {
    style: {
      fontSize: 14,
      lineHeight: 1.5,
      color: 'var(--text-secondary)'
    }
  }, "Avec leur permission, WinBoost AI peut cloner la voix d\u2019un membre de l\u2019\u00e9quipe. Chaque appel que votre AI Phone r\u00e9pond ou fait sonne alors comme votre propre \u00e9quipe, et les leads atterrissent dans votre calendrier.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) auto minmax(0,1fr) auto minmax(0,1fr)',
      alignItems: 'start',
      gap: 6
    }
  }, [['mic', 'Enregistrer un \u00e9chantillon', 'Un membre de l\u2019\u00e9quipe dit oui'], ['orbit', 'L\u2019IA apprend la voix', 'M\u00eame ton, m\u00eame chaleur'], ['cal', 'Les leads sont r\u00e9serv\u00e9s', 'Leads dans votre calendrier']].flatMap(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 3),
      k = _ref3[0],
      t = _ref3[1],
      s = _ref3[2];
    var icon = k === 'orbit' ? React.createElement("img", {
      src: A + 'orbit.png',
      alt: "",
      style: {
        width: 26,
        height: 26,
        display: 'block'
      }
    }) : React.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }, React.createElement("path", {
      d: k === 'mic' ? 'M12 15a3.5 3.5 0 0 0 3.5-3.5v-6a3.5 3.5 0 1 0-7 0v6A3.5 3.5 0 0 0 12 15ZM5 11.5a7 7 0 0 0 14 0M12 15v6.5M8.5 21.5h7' : 'M4 6.5h16v14H4zM4 10.5h16M8.5 3v4M15.5 3v4M8 14.5l2.5 2.5 5-5',
      stroke: "var(--wb-orange)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
    var step = React.createElement("div", {
      key: k,
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 5,
        minWidth: 0
      }
    }, React.createElement("span", {
      style: {
        width: 44,
        height: 44,
        borderRadius: '50%',
        background: 'var(--grad-brand-soft)',
        border: '1px solid rgba(252,99,6,.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, icon), React.createElement("span", {
      style: {
        fontSize: 13,
        fontWeight: 800,
        lineHeight: 1.2,
        color: 'var(--text-primary)'
      }
    }, t), React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.3,
        color: 'var(--text-secondary)'
      }
    }, s));
    return i < 2 ? [step, React.createElement("span", {
      key: k + '-a',
      "aria-hidden": "true",
      style: {
        marginTop: 12,
        color: 'var(--wb-orange)',
        fontSize: 16,
        fontWeight: 800
      }
    }, "\u2192")] : [step];
  })))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      minWidth: 0
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Questions sur le fonctionnement"), React.createElement("div", {
    style: {
      fontSize: 14
    }
  }, React.createElement(VAccordion, {
    items: VOICE_FAQ
  })))), React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: VOICE_FAQ.map(function (f) {
          return {
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: f.a
            }
          };
        })
      })
    }
  }), React.createElement("style", null, '.vx-grid{display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:clamp(20px,3vw,44px);align-items:start}.vx-row{display:grid;grid-template-columns:24px minmax(0,1fr) auto;gap:12px;align-items:center;padding:12px 16px}.vx-vis{display:flex;justify-content:flex-end;min-width:0;max-width:210px}@media(max-width:1000px){.vx-grid{grid-template-columns:minmax(0,1fr)}}@media(max-width:620px){.vx-row{grid-template-columns:24px minmax(0,1fr)}.vx-vis{grid-column:2;justify-content:flex-start}}'));
}
Object.assign(window, {
  VoiceHow: VoiceHow
});